<template>
  <admin-layout>
    <div class="row">
      <div class="col-lg-12 text-right">
        <h5>
          <router-link to="/a/posts/add" class="btn btn-success">+ Új cikk feltöltése </router-link>
        </h5>
      </div>
    </div>
    <div id="w_posts">
        <div class="row">
            <div class="col-lg-12 content-title ml-lg-3 mt-1 mb-3">
                <h2 class="content-title">Cikkek</h2>
            </div>
        </div>
        <PostFilters :data="data" @onFiltersApplied="onFiltersApplied"></PostFilters>
        <Posts :data="data" :onFiltersApplied="filterApplied"></Posts>
    </div>
  </admin-layout>
</template>

<script>
    import PostFilters from "../../admin/posts/partials/PostFilters"
    import Posts from '../../admin/posts/partials/Posts'
    import AdminLayout from "../AdminLayout";

    export default{
        name: 'w_posts',
        data() {
            return {
                data: {
                    type: 'post',
                    path: '/posts',
                    filters: {
                        q: '',
                        date_from: '',
                        date_to: '',
                        menu_id: 1, //hirek
                        type: 'post',
                        user_id: '',
                        post_type: '',
                    },
                },
                filterApplied: {},
            }
        },
        components: {
            AdminLayout,
            PostFilters,
            Posts
        },
        methods: {
            onFiltersApplied(data) {
                this.filterApplied = data;
            }
        }
    }
</script>
